(function(){
  return
    //    if(location.href!=='https://www.ajwallpaper.com/products/3d-color-strip-582')return 
      let siteLogo = "https://cdn.shopify.com/s/files/1/1772/0301/t/9/assets/new-web_logo-USA.png?v=2585564459610801430"
      let countryMap = {
        'ca':{
          'currency':'CAD',
          'currencyFlag':'https://cdn.shopify.com/s/files/1/1772/0301/t/9/assets/canadian-flag-icon-10.png?v=1622554477',
          'topBannerMoreText':'<span class="message-promo"> | Get 10%OFF using code <u><b>CA10</b></u></span>',
          'popup':'.scappfancybox-wrap.scappfancybox-desktop.scappfancybox-type-html',
          'popupOverlay':'.scappfancybox-overlay',
          'couponCode':'CA10'
        },
        'gb':{
          'currency':'GBP',
          'currencyFlag':'https://cdn.shopify.com/s/files/1/1772/0301/t/9/assets/uk-flag.png?v=1623999619',
          'topBannerMoreText':'<span class="message-promo"> | Get 10%OFF using code <u><b>UK10</b></u></span>',
          'popup':'.scappfancybox-wrap.scappfancybox-desktop.scappfancybox-type-html',
          'popupOverlay':'.scappfancybox-overlay',
          'couponCode':'UK10'
        }
      }
      
       function generatePopupBox(currencyFlag, couponCode){
           return '<div id="geoPopup" data-sm-init="true">'+
          '            <div class="imagesWrapper">'+
          '                <img src='+siteLogo+'>'+
          '                <img src="'+currencyFlag+'">'+
          '            </div>'+
          '            <div class="title">Welcome to AJ Wallpaper!<span>Limited Time Offer!</span></div>'+
          '            <p>Using the Coupon Code below <br/>Get 10% OFF of ALL products.</p>'+
          '            <div class="sm-couponCode" data-sm-couponCode-text="'+couponCode+'">'+couponCode+'</div>'+
          '        </div>';
       }
        
       function runCurrencyChange(currency){
           console.log(currency)
           $('#currencies option').find('#currencies option:selected').remove();
           $('.selecter-options .selecter-item').find('.selecter-options .selecter-item:selected').remove();
           $('.selecter-options .selecter-item').removeClass("selected");
           $('.selecter-options .selecter-item[data-value="'+currency+'"]').addClass("selected");
           $('#currencies option[value="'+currency+'"]').attr("selected", "selected");
           $('.selecter-options .selecter-item[data-value="'+currency+'"]').attr("selected", "selected");
       }
      
       function runPopup(){
         $('#geoPopup').SlickModals({
                     popup_type: 'instant',
                     popup_animation: 'zoomIn',
                     popup_css: {
                         'width': '460px',
                         'background': '#fff',
                         'padding': '36px'
                     },
                     mobile_breakpoint: '480px',
                     mobile_position: 'topCenter',
                     mobile_css: {
                         'width': '100%',
                         'background': '#fff',
                         'padding': '20px',
                         'margin': '0'
                     },
                        restrict_cookieSet: true,
                      restrict_cookieDays: '0'
                 });
       }

       function runTopBarUpdate(targetCountry){
          let checkExist = setInterval(function() {
            let topBarPath = '#spb-information-bar > div.spb_table > div > span'
            if ($(topBarPath).length) {
              console.log("run script - runTopBarUpdate");
              document.querySelector(topBarPath) && document.querySelector(topBarPath).insertAdjacentHTML("afterend", targetCountry)
              clearInterval(checkExist);
            }
          }, 1000);
       }
       
       function getCookie(key){
          let cookieValue = document.cookie.split('; ').find(row => row.startsWith(key));
          cookieValue = cookieValue && cookieValue.split('=')[1]
          return cookieValue
       }

       function setVisitorCountryCookie(value){
          document.cookie = `visitorCountry=${value}; SameSite=none; path=/;`
       }

        function runAllGeoScript (visitorCountry){
          console.log('run script - initialGeoCoreFeature')
          //  document.querySelector("#main_bg > div.top_bar > div > div.four.columns.top_bar_search.mobile_hidden").style.backgroundImage="url('"+countryMap[country].currencyFlag+"')";
          //  setTimeout(()=>document.querySelector("#spb-information-bar > div.spb_table > div > span") && document.querySelector("#spb-information-bar > div.spb_table > div > span").insertAdjacentHTML("afterend", countryMap[country].topBannerMoreText),8000)
          //  currencyChange(countryMap[country].currency);

          document.querySelector("body").insertAdjacentHTML("beforeend", generatePopupBox(countryMap[visitorCountry].currencyFlag,countryMap[visitorCountry].couponCode));
          runPopup()
          runTopBarUpdate(countryMap[visitorCountry].topBannerMoreText)
        }

        function initialGeoFn(){
          $.getJSON("https://ipgeolocation.abstractapi.com/v1/?api_key=d2c087b51f644e0180e056ad78e2c1ca", function(data) {
              console.log('Geo Info: '+data.country_code+' - '+data.country);
              let visitorCountry = data.country_code.toLowerCase();
              setVisitorCountryCookie(visitorCountry);
              countryMap[visitorCountry] && runAllGeoScript(visitorCountry);
          })
        }

        let siteCountry = window.location.host.slice(window.location.host.lastIndexOf('.')+1)
        console.log('Current site: '+siteCountry)
     
        let visitorCountry = getCookie('visitorCountry')
        if(visitorCountry){
          countryMap[visitorCountry] && runTopBarUpdate(countryMap[visitorCountry].topBannerMoreText)
        }else {
          initialGeoFn()
        }
       
       
     })(jQuery)
     
     
     